import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"

export const ActivitySummary = () => {
  const { i18n } = useTranslation()

  const activities: { activity: string; time: string }[] = useMemo(() => {
    return [
      {
        activity: "delivery man goes here",
        time: "10:00 AM",
      },
      {
        activity: "Order No. 11 has been requested.",
        time: "10:00 AM",
      },
      {
        activity: "Order No. 11 was rejected.",
        time: "10:00 AM",
      },
      {
        activity: "A dispute has been filed on coupon number 11.",
        time: "10:00 AM",
      },
      {
        activity: "A dispute has been filed on coupon number 11.",
        time: "10:00 AM",
      },
    ]
  }, [i18n])
  return (
    <div className="container-fluid p-0">
      <h4 className="font-size-16 text-capitalize fw-semibold mb-4">
        {i18n.t("dashboard_todayActivity")}
      </h4>
      <div
        className="rounded-2"
        style={{
          border: "1px solid #30303014",
          boxShadow: "0px 1px 5px 0px #00000026",
        }}
      >
        {activities.map((activity, index) => (
          <div
            key={index}
            style={{ border: "1px solid #30303014" }}
            className="d-flex align-items-center justify-content-start gap-2 p-2"
          >
            <img
              src="https://placehold.co/30x30/png"
              className="rounded-circle"
              style={{ width: "24px", height: "24px" }}
              alt="avatar"
            />
            <div className="d-flex flex-column align-items-start justify-content-start gap-2">
              <p className="m-0 font-size-14 fw-medium">{activity.activity}</p>
              <div className="bg-primary-30 text-primary px-2 rounded-2 d-flex align-items-center gap-1">
                <i className="mdi mdi-clock-outline"></i>
                <p className="m-0 font-size-14 fw-semibold">{activity.time}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
